module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-black-58a8a3e824392.45b7723.woff2";